import DeleteConfirm from '@/components/Crud/Modals/Confirm';
import ModalNewDiscount from '@/components/modals/ModalNewDiscount';
import { config } from '@/config/constants.js';
import { mapState } from 'vuex';

import Vue from 'vue';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

Vue.use(VueToast);

export default {
  name: 'CrudList',
  props: {
    parentUrlKey: {
      type: String,
      default: '',
    },
    parentStoreName: {
      type: String,
      default: '',
    },
    parentStoreUrl: {
      type: String,
      default: null,
    },
    parentUrlKeyTwo: {
      type: String,
      default: '',
    },
    parentStoreNameTwo: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: 'Section Title',
    },
    storeName: {
      type: String,
      default: '',
    },
    canAdd: {
      type: Boolean,
      default: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
    canShow: {
      type: Boolean,
      default: false,
    },
    canDelete: {
      type: Boolean,
      default: true,
    },
    canSearch: {
      type: Boolean,
      default: false,
    },
    canExport: {
      type: Boolean,
      default: false,
    },
    canImport: {
      type: Boolean,
      default: false,
    },
    labelBack: {
      type: String,
      default: 'Atras',
    },
    sortable: {
      type: Boolean,
      default: false,
    },
    labelAddNew: {
      type: String,
      default: 'Agregar Nuevo',
    },
    labelEdit: {
      type: String,
      default: 'Editar',
    },
    labelShow: {
      type: String,
      default: 'Detalle',
    },
    labelDelete: {
      type: String,
      default: 'Eliminar',
    },
    labelExport: {
      type: String,
      default: 'CSV',
    },
    labelModalDelete: {
      type: String,
      default: 'Eliminar',
    },
    labelModalConfirm: {
      type: String,
      default: '¿Quieres eliminar este registro?',
    },
    deleteMultiple: {
      type: Boolean,
      default: false,
    },
  },
  components: { DeleteConfirm, ModalNewDiscount },
  watch: {
    async search(text) {
      this.options.search = text;
      // await this.$store.dispatch(this.storeName + "/getList", this.options);
    },
    options: {
      async handler() {
        await this.$store.dispatch(this.storeName + '/getList', this.options);
      },
      deep: true,
    },
  },
  data() {
    return {
      token: this.$store.state['Authenticate'].token,
      search: '',
      selected_item: '',
      confirmDelete: false,
      showAddDiscount: false,
      options: {},
    };
  },
  created() {
    this.options = {
      ...this.$store.state[this.storeName].options,
    };

    if (this.parentUrlKeyTwo) {
      this.options[this.parentUrlKeyTwo] = this.$route.params[
        this.parentUrlKeyTwo
      ];
    }

    if (this.parentUrlKey) {
      this.options[this.parentUrlKey] = this.$route.params[this.parentUrlKey];
    }

    this.options.search = '';
    this.options.itemsPerPage = 10;
    this.page = 1;
  },
  computed: {
    ...mapState({
      user: (state) => state.Authenticate.user,
    }),

    status() {
      return this.$store.state[this.storeName].status;
    },
    list() {
      return this.$store.state[this.storeName].list;
    },
    // selected_rows() {
    //   return this.$store.state[this.storeName].selected_rows;
    // },
    total() {
      return this.$store.state[this.storeName].total;
    },
    header() {
      return this.$store.state[this.storeName].header;
    },
    selected_rows: {
      get() {
        return this.$store.state[this.storeName].selected_rows;
      },
      set(value) {
        this.$store.commit(this.storeName + '/updateSelectedRows', value);
      },
    },
  },
  methods: {
    async refreshList() {
      await this.$store.dispatch(this.storeName + '/getList', this.options);
    },

    buildRootUrl() {
      if (this.parentUrlKey && this.parentStoreName) {
        if (this.parentUrlKeyTwo && this.parentStoreNameTwo) {
          return (
            '/admin/' +
            this.parentStoreName.toLowerCase() +
            '/' +
            this.$route.params[this.parentUrlKey] +
            '/' +
            this.parentStoreNameTwo.toLowerCase() +
            '/' +
            this.$route.params[this.parentUrlKeyTwo] +
            '/' +
            this.storeName.toLowerCase()
          );
        } else {
          return (
            '/admin/' +
            this.parentStoreName.toLowerCase() +
            '/' +
            this.$route.params[this.parentUrlKey] +
            '/' +
            this.storeName.toLowerCase()
          );
        }
      } else {
        return '/admin/' + this.storeName.toLowerCase();
      }
    },
    async addItem() {
      if (this.storeName === 'Discounts') {
        this.showAddDiscount = true;
      } else {
        await this.$router.push(this.buildRootUrl() + '/add');
      }
    },
    async editItem(item) {
      const itemId = item._id || item.id;
      await this.$router.push(this.buildRootUrl() + '/edit/' + itemId);
    },
    async showItem(item) {
      const itemId = item._id || item.id;
      await this.$router.push(this.buildRootUrl() + '/show/' + itemId);
    },
    async backItem() {
      const self = this;
      if (self.parentUrlKey && self.parentStoreName) {
        if (self.parentUrlKeyTwo && self.parentStoreNameTwo) {
          self.$router.push(
            '/admin/' +
              self.parentStoreName.toLowerCase() +
              '/' +
              this.$route.params[self.parentUrlKey] +
              '/' +
              self.parentStoreNameTwo.toLowerCase()
          );
        } else {
          self.$router.push('/admin/' + self.parentStoreName.toLowerCase());
        }
      } else {
        self.$router.push('/admin/' + self.parentStoreName.toLowerCase());
      }
    },
    deleteItem(item) {
      this.selected_item = item;
      this.confirmDelete = true;
    },
    hideConfirmDelete() {
      this.selected_item = '';
      this.confirmDelete = false;
    },
    async confirmDeleteItem() {
      const self = this;
      if (!this.selected_item && this.selected_rows.length) {
        const ids = this.selected_rows.map((r) => (r['id'] ? r['id'] : r));
        self.$store.dispatch(this.storeName + '/bulkDelete', ids).then(() => {
          self.$store.dispatch(this.storeName + '/getList', this.options);
          self.confirmDelete = false;
        });
      } else {
        self.$store
          .dispatch(this.storeName + '/delete', this.selected_item)
          .then(() => {
            self.$store.dispatch(this.storeName + '/getList', this.options);
            self.confirmDelete = false;
          })
          .catch((error) => {
            if (error.code === 'ERROR_ACTIVE_APPOINTMENT') {
              Vue.$toast.error(
                'No es posible eliminar, esta persona tiene citas activas',
                { position: 'top-right' }
              );
            }
          });
      }
    },
    exportCSV() {
      try {
        const queryString = Object.keys(this.options)
          .map((key) => key + '=' + encodeURIComponent(this.options[key]))
          .join('&');
        const url =
          config.api_url +
          this.storeName.toLowerCase() +
          '?format=csv&' +
          queryString +
          '&authorization=' +
          this.token;

        window.location.href = url;
      } catch (error) {
        this.$toast.error('Error al descargar el CSV', {
          position: 'top-right',
        });
      }
    },
    openFileInput() {
      this.$refs.fileInputCsv.click();
    },
    async handleFileChange(event) {
      console.log('change input');
      const self = this;
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        const allowedExtensions = ['xls', 'xlsx', 'csv'];
        const fileExtension = selectedFile.name
          .split('.')
          .pop()
          .toLowerCase();
        if (allowedExtensions.includes(fileExtension)) {
          let data = {
            ...this.options,
            file: selectedFile,
          };
          await self.$store
            .dispatch(this.storeName + '/import', data)
            .then((resp) => {
              self.$store.dispatch(this.storeName + '/getList', this.options);
              const fileInput = this.$refs.fileInputCsv;
              if (fileInput) {
                fileInput.value = '';
              }
            });
        } else {
          // El archivo no tiene una extensión válida
          console.error(
            'Formato de archivo no válido. Selecciona un archivo de Excel o CSV.'
          );
        }
      }
    },
    async searchRows() {},

    editProfile() {
      this.$router.push('/admin/profile');
    },
  },
};
